import { render, staticRenderFns } from "./user-management.vue?vue&type=template&id=3f6fc3c4&scoped=true"
import script from "./user-management.vue?vue&type=script&lang=js"
export * from "./user-management.vue?vue&type=script&lang=js"
import style0 from "./user-management.vue?vue&type=style&index=0&id=3f6fc3c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6fc3c4",
  null
  
)

export default component.exports